import { Button, TagGroup, TagList } from 'react-aria-components';
import Tag from '@/assets/icons/Tag.svg';
import X from '@/assets/icons/X.svg';
import * as Styled from './DiscountTags.styled';
import { useRemoveDiscountCode } from './useRemoveDiscountCode';
import { useCallback } from 'react';

interface DiscountTagsProps {
  discountCode: string;
}

export const DiscountTags = ({ discountCode }: DiscountTagsProps) => {
  const { clearDiscountCode, isPending } = useRemoveDiscountCode();

  const handleRemoveTag = useCallback(() => {
    if (!isPending) {
      clearDiscountCode(undefined);
    }
  }, [clearDiscountCode, isPending]);

  return (
    <TagGroup aria-label="Discount code" onRemove={handleRemoveTag}>
      <TagList>
        <Styled.DiscountTag textValue={discountCode}>
          <Tag />
          {discountCode}
          <Button
            aria-label="Remove discount."
            isPending={isPending}
            slot="remove"
          >
            <X />
          </Button>
        </Styled.DiscountTag>
      </TagList>
    </TagGroup>
  );
};
